<template>
  <div class="form__group">
    <div class="form__field">
      <div class="form__block">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
